import React from 'react'
import MissionVision from '../components/MissionVision';
import ServicesCarousel from '../components/ServicesCarousel';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import Expertise from '../components/Expertise';
import AboutCarousel from '../components/AboutCarousel';
import FAQ from '../components/FAQs';

const Homepage = () => {
  return (
    <div className='overflow-hidden bg-white'>
    <ServicesCarousel />
    <Services />
    <Testimonials />
    <MissionVision />
    <Expertise />
      <div className="mt-8 mx-4">
      <AboutCarousel /> 
        <FAQ/>
      </div>
    
  </div>
  )
}

export default Homepage
